import PropTypes from 'prop-types';
import ImageProp from '../../../commonComponents/propTypes/imageProp';

const propType = {
  _id: PropTypes.string,
  firstname: PropTypes.string,
  lastname: PropTypes.string,
  username: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.shape(ImageProp.propType)),
  image: PropTypes.shape(ImageProp.propType),
  genre: PropTypes.string,
  birthday: PropTypes.number,
  language: PropTypes.string,
  nationality: PropTypes.object,
  email: PropTypes.string,
  currency: PropTypes.string,
};

export default { propType };
